import * as CONSTRUCTOR from '../../generate';

export const sharedNoteResponse = CONSTRUCTOR.FRAGMENT({
  name: 'SharedNote',
  fragmentName: 'SharedNoteResponseFields',
  fields: `{
    id
    parent_type
    parent_id
    note
    privacy
    mu_name
    mu_preferred_name
    mu_aws_id
    created_at
    updated_at
  }`,
});

export const sharedNotesListResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListSharedNotesResponse',
  fragmentName: 'SharedNotesListResponseFields',
  fields: `{
    shared_notes {
      id
      parent_type
      parent_id
      note
      privacy
      mu_name
      mu_preferred_name
      created_at
    }
    total_count
    limit
    page
  }`,
});
